export default {
  app_title: 'ComfyUI',
  app_version: __COMFYUI_FRONTEND_VERSION__
}
